
import { Observable } from './druid/./druid/Observable';
import { combineLatest } from './druid/./druid/operator/combineLatest';

Observable.prototype.combineLatest = combineLatest;

declare module './druid/./druid/Observable' {
  interface Observable<T> {
    combineLatest: typeof combineLatest;
  }
}